import G from "./Glob.mjs";

/**
 * @type {AthenaNodeHelperClass}
 * @implements {AthenaNodeHelperObject}
 * @see {AthenaNodeHelperObject}
 */
const nodeHelper = class {
	/** @type {AthenaLibNode|undefined} */
	#data;
	/** @type {AthenaLibHelperObject|undefined} */
	#lib;
	/** @type {number|undefined} */
	#idx;
	/**
	 * @param {AthenaLibNode} data
	 * @param {AthenaLibHelperObject} lib
	 * @param {number} [idx]
	 */
	constructor(data, lib, idx) {
		this.#data = data;
		this.#lib = lib;
		this.#idx = idx;
	}
	/** @return {AthenaNodeHelperObject[]|false} */
	children() {
		if (! this.#data.children ) return false;
		return this.#data.children.map( (child, idx) => ( this.#lib.getNodeHelper( child,idx )))
	}

	/**
	 * @param {string} name
	 * @param {string} [lang]
	 * @return {any}
	 */
	getField(name, lang) {
		const f = this.#data[name];
		if ( Array.isArray( f ) ) return f;
		if ( typeof f === 'object') {
			const df = this.#lib.defaultLang();
			if ( typeof lang !== 'string' ) lang = this.#lib.curLang();
			if ( f[lang]) return f[lang];
			if ( f[df] ) return f[df];
			if ( Object.keys(f).length ) return f[Object.keys(f)[0]];
			return '';
		}
		return f;
	}
	/** @return {AthenaLibNode} */
	getData() {
		return G.clone(this.#data);
	}
	/**
	 * @param {string} [lang]
	 * @return {any}
	 */
	getDesc( lang ) {
		return this.getField('description', lang);
	}

	/**
	 * @return {number|undefined}
	 */
	getIndex() {
		return this.#idx;
	}

	/**
	 * @param {string} [lang]
	 * @return {any}
	 */
	getName( lang ) {
		return this.getField('name', lang);
	}

	getCode() {
		return this.#data.code;
	}

	getViewCode() {
		if ( this.#data.viewcode ) return this.#data.viewcode;
		return this.getCode();
	}

	showCode() {
		if ( this.#data.viewcode ) return this.#data.viewcode+' ('+this.#data.code+')';
		return this.getCode();
	}

	/** @return {boolean} */
	hasLeaf() {
		if ( this.#data.leaf ) return false;
		if ( this.#data.children ) return !! this.#data.children.find( l => l.leaf );
		return false;
	}

	/** @return {boolean} */
	isLeaf() {
		return !! this.#data.leaf;
	}

	/** @return {number} */
	qtChildren() {
		if ( ! this.#data.children ) return 0;
		return this.#data.children.length;
	}

	/** @return {AthenaNodeHelperObject} */
	root() {
		return this.#lib.root();
	}

}

/**
 * @type {AthenaLibHelperClass}
 * @implements {AthenaLibHelperObject}
 * @see {AthenaLibHelperObject}
 * @see {AthenaNodeHelperObject}
 */
const libHelper = class {
	/** @type {AthenaLibraryParsedRootNode|undefined} */
	#data;
	/** @type {Record<string,AthenaNodeHelperObject>} */
	#nodes = {};
	#curLang = 'it';

	/**
	 * @param {AthenaLibraryParsedRootNode} data
	 * @param {string} curLang
	 */
	constructor(data,curLang) {
		this.#data = data;
		if ( curLang ) this.#curLang = curLang;
	}

	/**
	 * @return {AthenaLibraryParsedRootNode}
	 */
	getData() {
		return this.root().getData();
	}

	/**
	 * @param {AthenaLibNode} data
	 * @param {number} [idx]
	 * @return {AthenaNodeHelperObject}
	 */
	getNodeHelper( data, idx ) {
		if ( typeof idx === 'number' && this.#nodes[ data.code ] ) {
			if ( this.#nodes[ data.code ].getIndex() !== idx ) delete this.#nodes[ data.code ];
		}
		if ( ! this.#nodes[ data.code ]) this.#nodes[ data.code ] = new nodeHelper( data, this, idx );
		return this.#nodes[ data.code ];
	}
	/** @return {AthenaNodeHelperObject} */
	root() {
		return this.getNodeHelper( this.#data );
	}
	/** @type {string} */
	curLang() {
		return this.#curLang
	}
	/** @type {string} */
	defaultLang() {
		return this.#data.defaultLanguage;
	}
	/**
	 * @param {string} name
	 * @param {string} [lang]
	 * @return {any}
	 */
	getField(name, lang) {
		return this.root().getField(name, lang);
	}
	/**
	 * @param {string} [lang]
	 * @return {any}
	 */
	getDesc( lang ) {
		return this.getField('description', lang);
	}
	/**
	 * @param {string} [lang]
	 * @return {any}
	 */
	getName( lang ) {
		return this.getField('name', lang);
	}
}

export default libHelper;